import React from 'react';
import { UserAction } from '../api';

export const isSkillCheckAcknowledgment = (action: UserAction) =>
  action.id === 'skill_check_result' || action.id === 'skill_result_ack';

const progressionIds = new Set(['skill_info_ack', 'before_combat_actions_pass', 'before_horror_pass',
  'pass_before_horror_before_combat_spells', 'pre_roll_before_skill_check_skip', 'auto_pass_skill_skip',
  'auto_pass_undead_combat_skip', 'pass_combat_spells', 'pass_before_combat_spells']);

export const isSkillCheckProgression = (action: UserAction) => progressionIds.has(action.id);

export function SkillCheckActionControls({ actions, loading, onExecuteAction }: {
  actions: UserAction[]; loading: boolean; onExecuteAction: (id: string) => void;
}) {
  return <div className="skill-check-action-controls" role="group" aria-label="Skill check controls">
    {actions.map(action => <button key={action.id} type="button" disabled={loading || !!action.disabled}
      title={action.description} onClick={() => { if (!loading && !action.disabled) onExecuteAction(action.id); }}>{isSkillCheckAcknowledgment(action) ? 'OK' : action.name}</button>)}
  </div>;
}
